import React, { useState } from "react";
import { Button } from "@mantine/core";
import { useServerApi } from "../hooks/userServerApi";
import { useDisclosure } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { IconCircleCheck, IconExclamationMark } from "@tabler/icons";
import ConfirmationModal from "./confirmationModal";
import { useTranslation } from "react-i18next";

const RenewalReinstateButton = ({ mainForm, disabled = false }) => {
  const [api] = useServerApi();
  const { _id: id, code, status } = mainForm.values;
  const [opened, { open, close }] = useDisclosure(false);
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation();

  const reinstate = async () => {
    if (saving) return;
    try {
      if (!id) return;
      setSaving(true);
      const result = await api.Renewal.reinstate(id);

      if (result?.success) {
        close();
        const nextStatus = result.data?.renewal?.status;
        if (nextStatus) {
          mainForm.setFieldValue("status", nextStatus);
        }
        mainForm.setFieldValue("rejection", undefined);
        showNotification({
          title: t("Renewal Reinstated"),
          color: "green",
          icon: <IconCircleCheck size={18} />,
          message: t("This renewal is active again."),
        });
        mainForm.notifyListRefresh?.();
        mainForm.reload?.();
      } else {
        throw result?.error ?? result?.message ?? "Reinstate failed";
      }
    } catch (error) {
      showNotification({
        title: t("Reinstate Error"),
        color: "red",
        icon: <IconExclamationMark size={18} />,
        message: error?.message ?? error,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <ConfirmationModal
        opened={opened}
        onClose={close}
        withCloseButton={false}
        size="lg"
        title={`Are you ready to reinstate the renewal ${code}?`}
        confirmList={[
          t("The renewal will be restored from terminated status."),
          t("You can confirm or continue processing this renewal afterwards."),
        ]}
        onConfirm={reinstate}
        agreeLabel={t("I agree to reinstate")}
      />

      <Button
        fullWidth
        color="green"
        onClick={open}
        loading={saving}
        disabled={disabled || !id || status !== "TERMINATE"}
      >
        {t("Reinstate Renewal")}
      </Button>
    </>
  );
};

export default RenewalReinstateButton;
